import { client } from '../apiClient';
import { ProjectGroup } from '../../models/projects/ProjectGroup';

const ENDPOINT = '/project-groups';

// Bez `.catch` — inaczej błąd rozwiązuje się jako dane i konsument dostaje obiekt AxiosError zamiast
// listy (`[...groups]` → "groups is not iterable", czyli wywalony render). React Query ma go dostać
// jako błąd i zostawić `data` niezdefiniowane.
export const getProjectGroups = async (): Promise<ProjectGroup[]> => {
  return client(true, true)
    .get<ProjectGroup[]>(ENDPOINT)
    .then((response) => response.data);
};

export const createProjectGroup = async (name: string, color?: string): Promise<ProjectGroup> => {
  return client(true, true)
    .post<ProjectGroup>(ENDPOINT, { name, color })
    .then((response) => response.data)
    .catch((error) => error);
};

export const updateProjectGroup = async (
  groupId: number,
  data: { name?: string; color?: string }
): Promise<ProjectGroup> => {
  return client(true, true)
    .put<ProjectGroup>(`${ENDPOINT}/${groupId}`, data)
    .then((response) => response.data)
    .catch((error) => error);
};

export const deleteProjectGroup = async (groupId: number): Promise<boolean> => {
  return client(true, true)
    .delete(`${ENDPOINT}/${groupId}`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const reorderProjectGroups = async (orderedIds: number[]): Promise<void> => {
  return client(true, true)
    .post(`${ENDPOINT}/reorder`, { orderedIds })
    .then((response) => response.data)
    .catch((error) => error);
};

export const assignProjectToGroup = async (
  projectId: number,
  groupId: number | null
): Promise<boolean> => {
  return client(true, true)
    .post(`${ENDPOINT}/assign`, { projectId, groupId })
    .then((response) => response.data)
    .catch((error) => error);
};

export const bulkAssignProjectsToGroup = async (
  projectIds: number[],
  groupId: number | null
): Promise<boolean> => {
  return client(true, true)
    .post(`${ENDPOINT}/bulk-assign`, { projectIds, groupId })
    .then((response) => response.data)
    .catch((error) => error);
};

export const getAllProjectGroups = async (): Promise<ProjectGroup[]> => {
  return client(true, true)
    .get<ProjectGroup[]>(`${ENDPOINT}/all`)
    .then((response) => response.data);
};
